
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/timeline",
      function () {
        return require("private-next-pages/resources/timeline.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/timeline"])
      });
    }
  